import { render, staticRenderFns } from "./PropertyOwnerFinancialStatement.vue?vue&type=template&id=a9c64378&scoped=true&"
import script from "./PropertyOwnerFinancialStatement.vue?vue&type=script&lang=js&"
export * from "./PropertyOwnerFinancialStatement.vue?vue&type=script&lang=js&"
import style0 from "./PropertyOwnerFinancialStatement.vue?vue&type=style&index=0&id=a9c64378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c64378",
  null
  
)

export default component.exports